// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "08f7c8a50eb14bca56ab" + ".chunk.js";
};